import React from "react";

/**
 * Generic table component with optional summary and caption
 *
 * @param {Object} props
 * @param {string} [props.id] id of table
 * @param {string} [props.summary] summary of table
 * @param {string} [props.caption] caption content
 * @param {boolean} [props.condensed] include 'table-condensed' in className string?
 * @param {React.ReactNode} [props.children]
 * @returns {React.JSX.Element}
 */
export default function TableWrapper({ id, summary, caption, condensed = true, children }) {
  return (
    <table
      id={id}
      className={`table table-bordered${condensed ? " table-condensed" : ""}`}
      role="grid"
      summary={summary}
    >
      <caption id="caption" className="sr-only" role="alert" aria-live="polite">
        {caption}
      </caption>
      {children}
    </table>
  );
}
